import React from 'react';
import { TextWithPreview } from './adSpotGrops/TextWithPreview';
import { StyledA } from './StyledA';
import { StyledColumn } from './StyledColumn';
import { TopHorizontalGroup } from './TopHorizontalGroup';

export const FlexFooter = () => (
    <TopHorizontalGroup>
        <StyledColumn>
            <TextWithPreview>
                by <StyledA href="https://loopme.com/">LoopMe LTD</StyledA> Follow us on{' '}
                <StyledA href="https://twitter.com/loopme">Twitter</StyledA> and{' '}
                <StyledA href="https://www.facebook.com/LoopMeMedia/">Facebook</StyledA>
            </TextWithPreview>
        </StyledColumn>
        <StyledColumn style={{ position: 'absolute', right: 0 }}>
            <TextWithPreview>
                &copy; LoopMe LTD / All rights reserved /{' '}
                <StyledA href="https://legal.loopme.com/privacy-center">Privacy Policy</StyledA>
            </TextWithPreview>
        </StyledColumn>
    </TopHorizontalGroup>
);
